module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Boz2Td/images/cover.jpg?1697126298269",
      "alt": "This image is the cover for the book Lord, Please Make Him Stop Drinking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lord, Please Make Him Stop Drinking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Lord Please Make Him Stop Drinking")]), _vm._v(" provides clear biblical examples of how wives can experience peace in their home from the up and down roller coaster of an alcoholic husband.")])]), _c('p', [_vm._v(" Christine Folk, communications coach and founder of Epiphany Approach, has put her wisdom on the page in "), _c('i', [_vm._v("Lord Please Make Him Stop Drinking")]), _vm._v(". Within its pages, Christine provides new skills for women to use when that angry alcoholic side of their husband shows up again. "), _c('i', [_vm._v("Lord Please Make Him Stop Drinking")]), _vm._v(" lays out a practical approach to applying God’s word to tumultuous situations and shows women how to:")]), _c('p', [_vm._v("Resist being provoked into his argument … againSpeak to him in \"his\" language and get him to stop yelling Reduce the intensity and frequency of his rants Know what his real problem is Know exactly what God is trying to tell them")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christine Lennard Folk\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0